const _excluded = ["select"];function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import { Translate, t } from "../../../../../I18N";
import { InputField, Select } from "../../../../Components/Forms";
import { useForm } from 'react-hook-form';
import { Button, Card } from "../../../../Components/UI";
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { createRowId } from "../shared";








const updateLinks = (
formData,
currentLinks,
parentId) =>
{
  const { select: selectedGroup } = formData,newData = _objectWithoutProperties(formData, _excluded);

  if (newData.rowId === 'NEW_ITEM') {
    const updatedLinks = [...(currentLinks || [])];

    newData.rowId = createRowId();

    if (selectedGroup) {var _updatedLinks$updated;
      (_updatedLinks$updated = updatedLinks[updatedLinks.findIndex((link) => link.rowId === selectedGroup)].subRows) === null || _updatedLinks$updated === void 0 ? void 0 : _updatedLinks$updated.push(
        newData
      );
    } else {
      updatedLinks.push(newData);
    }

    return updatedLinks;
  }

  switch (true) {
    case parentId && selectedGroup && parentId !== selectedGroup:
      return currentLinks === null || currentLinks === void 0 ? void 0 : currentLinks.map((link) => {
        if (link.rowId === parentId) {var _link$subRows;
          return _objectSpread(_objectSpread({},
          link), {}, {
            subRows: (_link$subRows = link.subRows) === null || _link$subRows === void 0 ? void 0 : _link$subRows.filter((subrow) => subrow.rowId !== newData.rowId) });

        }
        if (link.rowId === selectedGroup) {
          return _objectSpread(_objectSpread({}, link), {}, { subRows: [...(link.subRows || []), newData] });
        }
        return link;
      });

    case parentId && selectedGroup && parentId === selectedGroup:
      return currentLinks === null || currentLinks === void 0 ? void 0 : currentLinks.map((link) => {
        if (link.rowId === selectedGroup) {var _link$subRows2;
          return _objectSpread(_objectSpread({},
          link), {}, {
            subRows: (_link$subRows2 = link.subRows) === null || _link$subRows2 === void 0 ? void 0 : _link$subRows2.map((subrow) => {
              if (subrow.rowId === newData.rowId) {
                return newData;
              }
              return subrow;
            }) });

        }
        return link;
      });

    case parentId && !selectedGroup:
      return [
      ...((currentLinks === null || currentLinks === void 0 ? void 0 : currentLinks.map((link) => {
        if (link.rowId === parentId) {var _link$subRows3;
          return _objectSpread(_objectSpread({},
          link), {}, {
            subRows: (_link$subRows3 = link.subRows) === null || _link$subRows3 === void 0 ? void 0 : _link$subRows3.filter((subrow) => subrow.rowId !== newData.rowId) });

        }
        return link;
      })) || []),
      newData];


    case Boolean(!parentId && selectedGroup):
      return currentLinks === null || currentLinks === void 0 ? void 0 : currentLinks.reduce((acc, link) => {
        if (link.rowId !== newData.rowId && link.rowId !== selectedGroup) {
          acc.push(link);
        }
        if (link.rowId === selectedGroup) {
          acc.push(_objectSpread(_objectSpread({}, link), {}, { subRows: [...(link.subRows || []), newData] }));
        }
        return acc;
      }, []);

    case !parentId && !selectedGroup:
      return currentLinks === null || currentLinks === void 0 ? void 0 : currentLinks.map((link) => {
        if (link.rowId === newData.rowId) {
          return newData;
        }
        return link;
      });

    default:
      return currentLinks;
  }
};

const MenuForm = ({ closePanel, submit, linkToEdit, links = [] }) => {var _linkToEdit$_id, _window, _window$location;
  const groups = useRef([
  { label: t('System', 'No Group', 'No Group', false), value: '', key: '-' }]
  );

  useEffect(() => {
    links.forEach((link) => {
      if (link.subRows) {
        groups.current.push({
          label: t('Menu', link.title, link.title, false),
          value: link.rowId,
          key: link.rowId
        });
      }
    });
    // it's only important to get groups on first render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    values: {
      rowId: (linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.rowId) || '',
      title: (linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.title) || '',
      type: (linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.type) || 'link',
      url: (linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.url) || '',
      subRows: (linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.subRows) || [],
      _id: linkToEdit === null || linkToEdit === void 0 ? void 0 : (_linkToEdit$_id = linkToEdit._id) === null || _linkToEdit$_id === void 0 ? void 0 : _linkToEdit$_id.toString(),
      select: linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.parentId
    },
    mode: 'onSubmit'
  });

  const onSubmit = (formValues) => {
    const formData = formValues;

    if (!formData.rowId) {
      formData.rowId = 'NEW_ITEM';
    }

    if (formData.type === 'link') {
      delete formData.subRows;
    }

    const updatedLinks = updateLinks(formData, links, linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.parentId);

    submit(updatedLinks || []);
  };

  const hostname = ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin) || '';

  return (/*#__PURE__*/
    _jsx("div", { className: "relative h-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "p-4 mb-4 rounded-md border border-gray-50 shadow-sm bg-primary-100 text-primary-700" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-1 items-center w-full text-base font-semibold" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "w-5 h-5 text-sm" }, void 0, /*#__PURE__*/
    _jsx(CheckCircleIcon, {})
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Using URLs")
    ), /*#__PURE__*/
    _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "If it is an external URL, use a fully formed URL. Ie. http://www.uwazi.io."

    ), /*#__PURE__*/
    _jsx("br", {}), /*#__PURE__*/
    _jsx(Translate, { translationKey: "Navigation menu tool tip part 1" }, void 0, "If it is an internal URL within this website, be sure to delete the first part"

    ), ' ', "(",
    hostname, "),", ' ', /*#__PURE__*/
    _jsx(Translate, { translationKey: "Navigation menu tool tip part 2" }, void 0, "leaving only a relative URL starting with a slash character. Ie. /some_url."

    )
    )
    ), /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(onSubmit), id: "menu-form" }, void 0, /*#__PURE__*/
    _jsx(Card, {
      title:
      (linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.type) === 'group' ? /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Group") : /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Link") }, void 0, /*#__PURE__*/



    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "link-title",
      "data-testid": "menu-form-link-title",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Title") },
    register('title', { required: true }), {
      hasErrors: !!errors.title })
    ),
    (linkToEdit === null || linkToEdit === void 0 ? void 0 : linkToEdit.type) === 'link' && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "link-url",
      "data-testid": "menu-form-link-url",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "URL") },
    register('url', { required: true }), {
      hasErrors: !!errors.url })
    ), /*#__PURE__*/
    React.createElement(Select, _extends({
      id: "link-group",
      "data-testid": "menu-form-link-group",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Group") },
    register('select'), {
      options: groups.current })
    )
    )

    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex absolute bottom-0 gap-2 px-4 py-3 w-full" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: closePanel,
      className: "grow",
      "data-testid": "menu-form-cancel" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", type: "submit", form: "menu-form", "data-testid": "menu-form-submit" }, void 0,
    linkToEdit !== null && linkToEdit !== void 0 && linkToEdit.title ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Update") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add")
    )
    )
    ));

};

export { MenuForm, updateLinks };